import { render } from "./ZapiBackButton.vue?vue&type=template&id=1f52c44c&scoped=true"
import script from "./ZapiBackButton.vue?vue&type=script&lang=js"
export * from "./ZapiBackButton.vue?vue&type=script&lang=js"

import "./ZapiBackButton.vue?vue&type=style&index=0&id=1f52c44c&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f52c44c"]])

export default __exports__